import { render, staticRenderFns } from "./MenuInt.vue?vue&type=template&id=28434fab&scoped=true&"
import script from "./MenuInt.vue?vue&type=script&lang=js&"
export * from "./MenuInt.vue?vue&type=script&lang=js&"
import style0 from "./MenuInt.vue?vue&type=style&index=0&id=28434fab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28434fab",
  null
  
)

export default component.exports